/* eslint-disable max-len */
import {statusRequestEnum} from './detail-request.enum';

import {
// computed,
  markRaw,
} from 'vue';

import {
  useNormalizer,
} from '@sttedra_ui/framework';

import DetailRequestApproved from './detail-request-approved/DetailRequestApproved.vue';
import DetailRequestPendingVerification from './detail-request-pending-verification/DetailRequestPendingVerification.vue';
import DetailRequestWithoutBonification from './detail-request-without-bonification/DetailRequestWithoutBonification.vue';
import DetailRequestIncorrectData from './detail-request-incorrect-data/DetailRequestIncorrectData.vue';
import DetailRequestBlockedMisuse from './detail-request-blocked-misuse/DetailRequestBlockedMisuse.vue';

const {
  getNumber,
  getBoolean,
} = useNormalizer();

export default class DetailRequestViewState {
  isVisible;

  _detailModel;
  get detailModel() {
    return this._detailModel;
  }

  set detailModel(newValue) {
    const data = {
      ...newValue || {},
      ...newValue?.consolidatedRegister || {},
    };

    this._detailModel = data;
  }

  _stateId;
  get stateId() {
    return this._stateId;
  }

  set stateId(newValue) {
    const stateId = getNumber(newValue?.consolidatedRegister?.stateId) ?? getNumber(newValue?.stateId) ?? null;
    const isNotificable = getBoolean(newValue?.consolidatedRegister?.notificable) ?? getBoolean(newValue?.notificable) ?? false;

    if (!stateId) {
      this._stateId = null;
      return;
    }

    if (stateId === statusRequestEnum.APPROVED && !isNotificable) {
      this._stateId = statusRequestEnum.PENDING_VERIFICATION;
      return;
    }

    this._stateId = stateId;
  }

  _title;
  get title() {
    return this._title;
  }

  set title(stateId) {
    if (!stateId) return '';

    const statusTitles = {
      [statusRequestEnum.APPROVED]: 'Tu código para el descuento',
      [statusRequestEnum.PENDING_VERIFICATION]: 'Identificación pendiente de verificación',
      [statusRequestEnum.USER_REGISTER_WITHOUT_BONIFICATION]: 'Solicitud tramitada',
      [statusRequestEnum.INCORRECT_USER_DATA]: 'Identificación incorrecta',
      [statusRequestEnum.BLOCKED_BY_MISUSE]: 'Bloqueado por uso indebido',
    };

    this._title = statusTitles[stateId] || '';
  }

  _component;
  get component() {
    return this._component;
  }

  set component(stateId) {
    if (!stateId) return null;

    const components = {
      [statusRequestEnum.APPROVED]: DetailRequestApproved,
      [statusRequestEnum.PENDING_VERIFICATION]: DetailRequestPendingVerification,
      [statusRequestEnum.USER_REGISTER_WITHOUT_BONIFICATION]: DetailRequestWithoutBonification,
      [statusRequestEnum.INCORRECT_USER_DATA]: DetailRequestIncorrectData,
      [statusRequestEnum.BLOCKED_BY_MISUSE]: DetailRequestBlockedMisuse,
    };

    this._component = markRaw(components[stateId]) || null;
  }

  constructor(data) {
    this.isVisible = false;

    this.detailModel = data;
    this.stateId = data;

    // (!) always last...
    this.title = this.stateId;
    this.component = this.stateId;
  }
}
